import Vue from 'vue';

export class RelatorioPeriodo {

    /**
     *
     * @return {Promise}
     */
    static grid(json) {
        return new Promise((ok, fail) => {
            Vue.http.post('relatorio-periodo', json)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

}
